import { get } from "../../utils/objectHelpers";

$ {
    const tabs = component.tabs;
    const shopHeader = component.shopHeader;
    const spinner = component.spinner;
}

<if(tabs.length)>
    <div class="str-tabs" key="str-tabs">
        <for|tab, idx| of=tabs>
            <div id=tab.panelId
                key=idx
                role="tabpanel"
                class=`str-tabs__panel str-tabs__panel--${tab.regionKey.toLowerCase()}`
                aria-hidden=(state.selectedTabIndex !== idx)>

                <if(idx === 0)>
                    <str-shop-header ...shopHeader />
                </if>
                <str-region-builder regionsData=input region=tab.regionKey />
                <if(idx === 0)>
                    <str-loading-spinner ...spinner spinnerId="tab0LoadingSpinner"/>
                </if>
            </div>
        </for>
    </div>
</if>
